{
    "ConsidermovedtounresolvedasoverflowedLabel": "Betrachten Sie Anrufe, die auf nicht aufgelöste Geräte verschoben wurden, als übergelaufen:",
    "StatisticCalculations_SectionHeader": "Statistische Berechnungen",
    "StatisticCalculations_SectionPara": "Sie können wählen, ob Anrufe als übergelaufen betrachtet oder abgebrochen werden, wenn die Anwendung absichtlich",
    "NAME": "StatisticCalculations"
}